import React, { useEffect, useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, getCategoryColor, getPatientTypeRoleByAcronym, disableForm, enableForm, float2moeda, moeda2float } from '../../utils';
import Swal from 'sweetalert2';
import BankReconciliationHead from '../../components/financial/BankReconciliationHead';
import BankReconciliationBody from '../../components/financial/BankReconciliationBody';
import BankReconciliationMovements from '../../components/financial/BankReconciliationMovements';
import moment from 'moment-timezone';

const BankReconciliation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [bodyData, setBodyData] = useState([]);
  const [mainFinancialAccountData, setMainFinancialAccountData] = useState(null);
  const mainFinancialAccountDataRef = useRef(null);
  const apiCallXhr = useRef(null);
  const interval = useRef(null);

  React.useEffect(() => {
    mainFinancialAccountDataRef.current = mainFinancialAccountData;
  }, [mainFinancialAccountData]);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);
    setIsLoading(true);
    handleModalImportOfx();
    handleSetSelect2Data();
  }

  const updateHeadData = (data) => {
    let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
    if (!headData) {
      headData = {
        branchId: null,
        branchName: null,
        financialAccount: null,
        dateRange: null
      };
    }

    headData = {
      ...headData,
      ...data
    };

    localStorage.setItem('bankReconciliationHeadData', JSON.stringify(headData));

    fetchBodyData();
  }

  const handleModalImportOfx = () => {
    $('.js-bank-reconciliation-head-import-ofx').on('click', function() {
      let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
      //console.log('handleModalImportOfx', 'headData', headData);
      if (headData.financialAccount) {
        $('#modal-bank-reconciliation-import-ofx').modal('show');
        $('input[name="bank-reconciliation-account-id"]').val(headData.financialAccount?.info?.ID);
      } else {
        window.toast({
          error: true,
          text: 'Selecione uma conta financeira'
        });
      }
    });

    $(document).on('submit', '.js-bank-reconciliation-import-ofx-form', function(e) {
      let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
      //console.log('submitForm', 'headData', headData);
      e.preventDefault();
      const formData = new FormData(this);
      formData.append('bank-reconciliation-branch-id', headData.branchId);
      let selfBtn = $(this).find('button[type="submit"]');
      selfBtn.prop('disabled', true);

      let startDate = headData.dateRange ? headData.dateRange.split('|')[0] : moment().startOf('month').format('YYYY-MM-DD');
      let endDate = headData.dateRange ? headData.dateRange.split('|')[1] : moment().endOf('day').format('YYYY-MM-DD');

      Swal.fire({
        title: 'ATENÇÃO: Confirme o período de importação',
        text: `Esta importação irá processar as movimentações do período de ${startDate} até ${endDate}. Deseja continuar?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          apiCall({
            method: 'POST',
            endpoint: 'api/v1/financial/bank_reconciliation/import_ofx',
            data: formData,
            processData: false,
            contentType: false,
            successCallback: function(res) {
              window.toast({
                error: res.error,
                text: res.message
              });
              if (!res.error) {
                $('.js-bank-reconciliation-import-ofx-form').trigger('reset');
                $('#modal-bank-reconciliation-import-ofx').modal('hide');
                selfBtn.prop('disabled', false);
                fetchBodyData();
              }
            },
            errorCallback: function(res) {
              window.toast({
                error: res.error,
                text: res.message
              });
              selfBtn.prop('disabled', false);
            }
          });
        }
      });
    });

    $('.js-bank-reconciliation-head-edit-balance').on('click', function(e) {
      e.preventDefault();
      handleOpenEditBalanceModal();
    });

    $('input[name="bank-reconciliation-edit-balance-start-date"]').on('change', function() {
      let startDate = moment($('input[name="bank-reconciliation-edit-balance-start-date"]').val(), 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
      $('.js-bank-reconciliation-edit-balance-end-date').val(startDate).trigger('change');
    });

    $(document).on('submit', '.js-bank-reconciliation-edit-balance-form', function(e) {
      e.preventDefault();
      //console.log('submitEditBalanceForm');
      disableForm('.js-bank-reconciliation-edit-balance-form');
      Swal.fire({
        title: 'Editar saldo da conta',
        text: 'Tem certeza que deseja editar o saldo da conta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
          //console.log('confirmed');
          let formData = {
            branchId: headData.branchId,
            accountId: headData.financialAccount.id,
            startDate: $('input[name="bank-reconciliation-edit-balance-start-date"]').val(),
            balance: moeda2float($('input[name="bank-reconciliation-edit-balance"]').val())
          }
          apiCall({
            method: 'POST',
            endpoint: 'api/v1/financial/bank_reconciliation/edit_balance',
            data: formData,
            successCallback: function(res) {
              window.toast({
                error: res.error,
                text: res.message
              });
              if (!res.error) {
                $('.js-bank-reconciliation-edit-balance-form').trigger('reset');
                $('#modal-bank-reconciliation-edit-balance').modal('hide');
                fetchBodyData();
              }
            },
            errorCallback: function(res) {
              window.toast({
                error: res.error,
                text: res.message
              });
            }
          });
        } else {
          //console.log('cancelled');
          enableForm('.js-bank-reconciliation-edit-balance-form');
        }
      });
    });
  }

  const handleOpenEditBalanceModal = () => {
    $('#modal-bank-reconciliation-edit-balance').modal('show');
    //console.log('mainFinancialAccountData', mainFinancialAccountDataRef.current);

    if (mainFinancialAccountDataRef.current) {
      $('input[name="bank-reconciliation-edit-balance-start-date"]').val(mainFinancialAccountDataRef.current.account_base_balance.DATA_INICIO).trigger('change');
      $('input[name="bank-reconciliation-edit-balance"]').val(float2moeda(mainFinancialAccountDataRef.current.account_base_balance.SALDO)).trigger('change');

      // get one day before start date
      let startDate = moment(mainFinancialAccountDataRef.current.account_base_balance.DATA_INICIO, 'DD/MM/YYYY').subtract(1, 'days').format('YYYY-MM-DD');
      $('.js-bank-reconciliation-edit-balance-end-date').val(startDate).trigger('change');
    } else {
      $('input[name="bank-reconciliation-edit-balance-start-date"]').val('').trigger('change');
      $('input[name="bank-reconciliation-edit-balance"]').val('').trigger('change');
    }
  }

  const handleSetSelect2Data = () => {
    let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));

    if (headData?.branchId) {
      //console.log('bankReconciliationHead', 'headData.branchId', headData.branchId);
      setTimeout(() => {
        $('.js-bank-reconciliation-head-branches-selector').val(headData.branchId).trigger('change');
        $('.js-bank-reconciliation-head-branches-selector').trigger('select2:select');
        $('#insert_btp_branch_id').val(headData.branchId)
      }, 1000);
    }

    if (headData?.financialAccount) {
      setTimeout(() => {
        $('select[name="financial_account_id"]').html('');
        $('select[name="financial_account_id"]').append(`<option value="${headData.financialAccount.id}" selected>${headData.financialAccount.text}</option>`).trigger('change');
        $('select[name="financial_account_id"]').trigger('select2:select');
      }, 1000);
    }
  }

  const fetchBodyData = () => {
    let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
    if (headData.branchId && headData.financialAccount) {
      if (apiCallXhr.current) {
        apiCallXhr.current.abort();
      }
      $('.BankReconciliationTabsContent').block(window._loader.loading);
      apiCallXhr.current = apiCall({
        method: 'GET',
        endpoint: 'api/v1/financial/bank_reconciliation/pending_conciliations',
        data: {
          branchId: headData.branchId,
          accountId: headData.financialAccount.id,
          startDate: headData.dateRange ? headData.dateRange.split('|')[0] : moment().startOf('month').format('YYYY-MM-DD'),
          endDate: headData.dateRange ? headData.dateRange.split('|')[1] : moment().endOf('day').format('YYYY-MM-DD')
        },
        successCallback: function(res) {
          setBodyData(res.data);
          $('.BankReconciliationTabsContent').unblock();
          apiCallXhr.current = null;
        },
        errorCallback: function(res) {
          //console.log('fetchBodyData', res);
          apiCallXhr.current = null;
          $('.BankReconciliationTabsContent').unblock();
        }
      })
    }
  }

  const updateBodyData = (idx, data) => {
    /*const updatedBodyData = [...bodyData];
    updatedBodyData[idx] = data;
    setBodyData(updatedBodyData);*/

    fetchBodyData();
  }

  const removeBodyData = (idx) => {
    /*const updatedBodyData = [...bodyData];
    updatedBodyData.splice(idx, 1);
    setBodyData(updatedBodyData);*/

    fetchBodyData();
  }
  
  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);

    //tableRef.setFetchTableData(fetchTableData);
  }, []);

  const [currentTab, setCurrentTab] = useState('conciliations');

  const renderTabContent = () => {
    if (currentTab === 'conciliations') {
      return <BankReconciliationBody isLoading={isLoading} updateHeadData={updateHeadData} bodyData={bodyData} updateBodyData={updateBodyData} removeBodyData={removeBodyData} branches={branches} />;
    } else if (currentTab === 'movements') {
      return <BankReconciliationMovements isLoading={isLoading} updateHeadData={updateHeadData} bodyData={bodyData} updateBodyData={updateBodyData} removeBodyData={removeBodyData} fetchBodyData={fetchBodyData} mainFinancialAccountData={mainFinancialAccountData} />;
    }
  }

  /*console.log('============================================== RENDER BANK RECONCILIATION ==============================================');
  console.log('currentTab', currentTab);
  console.log('bodyData', bodyData);*/

  return (
    <>
      <BankReconciliationHead isLoading={isLoading} updateHeadData={updateHeadData} bodyData={bodyData} setMainFinancialAccountData={setMainFinancialAccountData} handleOpenEditBalanceModal={handleOpenEditBalanceModal} />
      <div className="col-sm-12">
        <div className="mb-3 card">
          <div className="col-12 p-2">
            <ul className="nav nav-tabs" id="BankReconciliationTabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button className={`nav-link ${currentTab === 'conciliations' ? 'active' : ''}`} id="conciliations-tab" data-bs-toggle="tab" data-bs-target="#conciliations" type="button" role="tab" aria-controls="conciliations" aria-selected="true" onClick={() => setCurrentTab('conciliations')}><h6>Conciliações pendentes</h6></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className={`nav-link ${currentTab === 'movements' ? 'active' : ''}`} id="movements-tab" data-bs-toggle="tab" data-bs-target="#movements" type="button" role="tab" aria-controls="movements" aria-selected="false" onClick={() => setCurrentTab('movements')}><h6>Movimentações</h6></button>
              </li>
            </ul>
            <div className="tab-content BankReconciliationTabsContent" id="BankReconciliationTabsContent">
              <div className={`tab-pane fade ${currentTab === 'conciliations' ? 'show active' : ''}`} id="conciliations" role="tabpanel" aria-labelledby="conciliations-tab">{currentTab === 'conciliations' && renderTabContent()}</div>
              <div className={`tab-pane fade ${currentTab === 'movements' ? 'show active' : ''}`} id="movements" role="tabpanel" aria-labelledby="movements-tab">{currentTab === 'movements' && renderTabContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

try {
  if (document.getElementById('js-bank-reconciliation-container')) {
    const container = document.getElementById('js-bank-reconciliation-container');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<BankReconciliation />);
  }
} catch(err) {
  console.error('Error rendering BankReconciliation: ', err);
}